import { TabStyles } from '@tableau/widgets';

export module SiteSettingsStyles {
  // Lifted from angular styles on the page
  export const HeaderStyle: React.CSSProperties = {
    fontFamily: 'BentonSans-Medium, Arial, Helvetica, sans-serif',
    fontSize: 15,
  };

  export const DisabledLink: React.CSSProperties = {
    color: TabStyles.Typography.Color.Disabled,
  };

  // Lifted from angular styles on the page
  export const BodyStyle: React.CSSProperties = {
    paddingLeft: '18px',
    paddingBottom: '18px',
  };

  // Angular checkboxes are aligned with the text for whatever reason
  export const CheckboxStyle: React.CSSProperties = {
    marginLeft: '-6px',
  };
}
